import React from 'react'
import * as Sentry from '@sentry/react'
import { PostHogProvider } from 'posthog-js/react'
import { createRoot } from 'react-dom/client'
import App from '../App'
import '../styles/application.css'

if (import.meta.env.PROD && import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.1,
  })
}

const posthogOptions = {
  api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
  defaults: '2025-11-30',
} as const

const container = document.getElementById('react-root')
if (container) {
  const root = createRoot(container)

  const app = (
    <React.StrictMode>
      <App />
    </React.StrictMode>
  )

  // Only wrap with PostHog in production when configured
  if (import.meta.env.PROD && import.meta.env.VITE_PUBLIC_POSTHOG_KEY) {
    root.render(
      <PostHogProvider apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY} options={posthogOptions}>
        {app}
      </PostHogProvider>
    )
  } else {
    root.render(app)
  }
}
